let UTILS = require("../libs/utils.js");
var v6655;
var v6656;
module.exports = {
  id: "ffa",
  name: "Free for All",
  alias: "ffa",
  leaderStats: ["score", "kills", "deaths"],
  description: "In this mode, you have no friends.\nEliminate as many opponents as you can.",
  descriptionLang: "game.mode.ffa.description"
};